export const TeamChannelPreview = ({ unread, name }: { unread: boolean, name: string }) => (
    <div className={`channel-preview__item ${unread && 'unread'}`}>
        {unread && <div className='channel-preview__item__unread' />}
        <p>{`${name}`}</p>
    </div>
);